import React from 'react';
import { Text, View, Pressable, Image, StyleSheet } from 'react-native';

import {
  Container,
  NavBar,
  Utils,
  OPComponent,
  Navigation,
  I18n,
  ArrowRight,
  Alert,
} from '../components';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getInvitationInfo,
  acceptInvitation,
  acceptEmployerInvitation,
  resetState,
} from './actions';

import { markNotificationAsRead } from '../notifications/actions';

const TEST_INVITE = {
  employerId: '133',
  employerName: 'Outpatient Lifestyle Cal',
  name: 'Lorien HW 7',
  role: 'Caregiver',
};

const TEST_INVITE_EMPLOYER_CASE = {
  caseEmployerId: '133',
  employerName: 'Outpatient Lifestyle Cal',
  name: 'Lorien HW 7',
  role: 'Caregiver',
};

class InviteAccept extends OPComponent {
  static navigatorButtons = NavBar && {
    rightButtons: [
      {
        text: I18n.t('invite.accept'),
        id: 'accept_invite',
      },
    ],
    leftButtons: [
      {
        text: I18n.t('invite.decline'),
        id: 'cancel',
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = {
      relationshipRoleId: 3,
    };

    this._guid = props.pendingInviteGuid;
  }

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;

    if (NavBar.handleButtonPress(componentId, buttonId)) return;

    if (buttonId === 'accept_invite') {
      this.acceptInvite();
    }
  };

  componentDidMount() {
    Utils.trackScreen('Invitations', 'Accept Sheet');
    Navigation.registerForButtonEvents(this);
    this.props.actions.getInvitationInfo(this.props.pendingInviteGuid);
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    this.props.actions.resetState();
    this.props.cb && this.props.cb();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.status === SUCCESS &&
      prevProps.status !== SUCCESS &&
      this.props.pendingInvite === null &&
      this.props.pendingInviteGuid === null
    ) {
      if (this.props.notificationId) {
        this.props.actions.markNotificationAsRead(this.props.notificationId);
      }
      Navigation.close(this.props);
    }

    if (this.props.status === FAILED && prevProps.status !== FAILED) {
      this.handleError();
    }
  }

  acceptInvite = () => {
    const { pendingInvite } = this.props;
    if (!pendingInvite) return;

    const inviteObj = { ...this.props.pendingInvite };

    if (pendingInvite.caseId) {
      inviteObj.roleId = this.state.relationshipRoleId;
      this.props.actions.acceptInvitation(inviteObj, this._guid);
    } else {
      this.props.actions.acceptEmployerInvitation(inviteObj, this._guid);
    }
  };

  goToRelationshipSelect = () => {
    Utils.trackEvent('Navigation', 'Load', 'Relationship Sheet');
    Navigation.push(
      {
        screen: 'SelectRelationship',
        title: I18n.ac('case.selectRelationship'),
        passProps: {
          setSelectedRole: (roleId) => {
            this.setState({ relationshipRoleId: roleId });
          },
          selectedRoleId: this.state.relationshipRoleId,
        },
        selectedRoleId: this.state.relationshipRoleId,
      },
      this.props.componentId
    );
  };

  relationshipNameFromId(roleId) {
    let roles = this.props.caseRoles.filter((r) => r.id === roleId);
    if (roles && roles.length > 0) return roles[0].name;
    else return '';
  }

  renderCaseInvite() {
    let { pendingInvite } = this.props;
    // pendingInvite = TEST_INVITE_EMPLOYER_CASE;

    if (!pendingInvite) return <Container renderActivityOverlay={true} />;

    const caseEmployerId = pendingInvite.caseEmployerId;

    let employerImageUri = caseEmployerId && Utils.employerImagePath(caseEmployerId);

    return (
      <View style={THEME.container}>
        <View style={styles.header}>
          <View style={styles.headerImageContainer}>
            {!!caseEmployerId && (
              <Image
                style={styles.logoImage}
                source={{ uri: employerImageUri }}
                resizeMode="contain"
              />
            )}
            {!caseEmployerId && (
              <Image style={styles.headerImage} source={require('../../../resources/icon.png')} />
            )}
          </View>

          <View style={styles.headerTextContainer}>
            <Text style={styles.caseNameText}>{pendingInvite.caseName}</Text>
            <Text style={styles.patientNameLabel}>{I18n.ce('patient.patientName')}</Text>
            <Text style={styles.textRegular}>{pendingInvite.patientName}</Text>
          </View>
        </View>

        {!pendingInvite.caseEmployerId && (
          <Pressable style={styles.relationshipButton} onPress={this.goToRelationshipSelect}>
            <View style={THEME.container}>
              <Text style={styles.relationshipLabelText}>
                {I18n.t('case.relationshipToPatient')}
              </Text>
              <Text style={styles.relationshipValueText}>
                {this.relationshipNameFromId(this.state.relationshipRoleId)}
              </Text>
            </View>
            <ArrowRight />
          </Pressable>
        )}

        <View style={styles.descriptionContainer}>
          <Text style={styles.descriptionLabel}>{I18n.t('case.caseDescription')}</Text>
          <Text style={styles.descriptionText}>{pendingInvite.caseDescription}</Text>
        </View>
      </View>
    );
  }

  renderEmployerInvite() {
    let { pendingInvite } = this.props;
    // pendingInvite = TEST_INVITE;

    if (!pendingInvite) return <Container renderActivityOverlay={true} />;

    const { employerId, employerName, name, role } = pendingInvite;

    let employerImageUri = Utils.employerImagePath(employerId);

    return (
      <View style={THEME.container}>
        <View style={styles.header}>
          <View style={styles.headerImageContainer}>
            <Image
              style={styles.logoImage}
              source={{ uri: employerImageUri }}
              resizeMode="contain"
            />
          </View>

          <View style={styles.headerTextContainer}>
            <Text style={styles.caseNameText}>{employerName}</Text>
            <Text style={styles.patientNameLabel}>{I18n.t('staff.staffName')}</Text>
            <Text style={styles.textRegular}>{name}</Text>
          </View>
        </View>

        <View style={styles.descriptionContainer}>
          <Text style={styles.descriptionLabel}>{I18n.t('employer.communityRole')}</Text>
          <Text style={[styles.descriptionText, styles.roleText]}>{role}</Text>
        </View>
      </View>
    );
  }

  renderContents() {
    let { pendingInvite } = this.props;
    // pendingInvite = TEST_INVITE;

    if (pendingInvite) {
      return pendingInvite.caseId ? this.renderCaseInvite() : this.renderEmployerInvite();
    }

    return null;
  }

  handleError() {
    let { errorMessage } = this.props;

    let msg = errorMessage && errorMessage.message;
    if (msg === 'This invitation does not exist.') {
      msg = I18n.t('invite.inviteInvalidMessage');
      if (this.props.notificationId) {
        this.props.actions.markNotificationAsRead(this.props.notificationId);
      }
    } else {
      msg = I18n.t('genericErrorMessage');
    }

    Alert.alert(null, msg, [{ text: 'OK', onPress: () => Navigation.close(this.props) }], {
      cancelable: false,
    });
  }

  render() {
    let { errorMessage, status } = this.props;

    return (
      <Container scrollView={true} renderActivityOverlay={status === REQUESTING}>
        {this.renderContents()}
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    backgroundColor: COLOR.contrast,
    padding: 25,
    borderBottomColor: COLOR.accent,
    borderBottomWidth: 1,
  },
  headerImageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 75,
    height: 75,
    backgroundColor: COLOR.textLight,
    borderColor: COLOR.text,
    borderWidth: 1,
    borderRadius: 10,
    overflow: 'hidden',
  },
  headerImage: {
    width: 51,
    height: 51,
  },
  logoImage: {
    width: 75,
    height: 75,
  },
  headerTextContainer: {
    flex: 1,
    paddingLeft: 20,
    justifyContent: 'center',
  },
  caseNameText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.large,
    color: COLOR.emphasis,
    marginBottom: 5,
  },
  patientNameLabel: {
    ...FONT.bold,
    fontSize: FONT_SIZE.tiny,
    color: COLOR.text,
    marginBottom: 2,
  },
  textRegular: THEME.textRegular,

  relationshipButton: {
    flexDirection: 'row',
    alignItems: 'center',
    borderTopWidth: 2,
    borderTopColor: COLOR.altContrast,
    borderBottomWidth: 2,
    borderBottomColor: COLOR.accent,
    paddingHorizontal: 25,
    paddingVertical: 15,
    backgroundColor: COLOR.contrast,
  },
  relationshipLabelText: {
    ...FONT.semibold,
    fontSize: FONT_SIZE.tiny,
    color: COLOR.text,
  },
  relationshipValueText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.regular,
    color: COLOR.textLight,
  },

  descriptionContainer: {
    flex: 1,
    padding: 25,
    backgroundColor: COLOR.contrast,
  },
  descriptionLabel: {
    ...FONT.bold,
    fontSize: FONT_SIZE.tiny,
    color: COLOR.text,
  },
  descriptionText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.regular,
    color: COLOR.textLight,
    marginTop: 20,
  },
  roleText: {
    marginTop: 5,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    caseRoles: state.entities.metaData.caseRoles,
    pendingInviteGuid: state.application.pendingInviteGuid,
    pendingInvite: state.screens.invites.pendingInvite,
    status: state.screens.invites.status,
    errorMessage: state.screens.invites.errorMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        acceptInvitation,
        acceptEmployerInvitation,
        getInvitationInfo,
        resetState,
        markNotificationAsRead,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InviteAccept);
